import React, { useEffect } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import config from "../../config";

const Thankyou = () => {
  useEffect(() => {
    document.title = `Thankyou | Agile Seekers`;
    document.getElementById("bodywrap").className = "thankyoumain";
  }, []);

  return (
    <>
      <Navbar />

      <section className="thankyou-banner">
        <Container fluid>
          <Row>
            <Col className="px-0 contimg">
              <h2>Thanks For Registering for the Course!</h2>
              <Image
                src={`${config.BASE_URL}/assets/images/contact.jpg`}
                className="img-fluid"
                alt="contimg"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="thankyou-form">
        <Container>
          <Row className="justify-content-md-center">
            <Col md={6} className="thank-left">
              <Col>
                <Link
                  to="/"
                  variant="primary"
                  className="text-center"
                  type="button"
                >
                  Back to Home
                </Link>
              </Col>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Thankyou;
